import React from 'react';
import { useSelector } from 'react-redux';

import { HELP_NUMBER } from 'dpl/shared/constants/breeder_app';
import Drawer, {
  DrawerItem,
  DrawerItemContext
} from 'dpl/common/components/Drawer';
import Icon from 'dpl/common/components/Icon';

import FaqItem from './FaqItem';

export default function BreederJoinFaqsSection() {
  const faqs = useSelector(({ server }) => server.pageSections.faqs);
  const faqItems = faqs.page_items;

  return (
    <div className="BreederJoinFaqsSection">
      <h3 className="f5 heading-5-md heading-4-lg heading-3-xl tl tc-ns mb7 mb16-sm">
        {faqs.title}
      </h3>
      <Drawer>
        <div className="mb4 mb6-sm">
          {faqItems.map(
            ({ title, long_description: description }) =>
              title &&
              description && (
                <DrawerItem
                  className="bb bw1 b--light-purple"
                  itemKey={title}
                  key={title}
                >
                  <DrawerItemContext.Consumer>
                    {({ isOpen, onClick }) => (
                      <FaqItem
                        title={title}
                        description={description}
                        isOpen={isOpen}
                        onClick={onClick}
                      />
                    )}
                  </DrawerItemContext.Consumer>
                </DrawerItem>
              )
          )}
        </div>
      </Drawer>
      <div className="BreederJoinFaqsSection__questions flex pv3 ph4 align-items-center bg-lighter-purple-50 stone-700">
        <Icon name="question-cloud" height="59px" width="50px" />
        <div className="ml4">
          <p className="f4-sm fw-medium mb1">Still have questions?</p>
          <p className="f2 f3-sm">
            Speak to one of our team members by giving us a call at{' '}
            <a className="underline" href={`tel:${HELP_NUMBER}`}>
              {HELP_NUMBER}
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
